import { render, staticRenderFns } from "./ChainEditDialog.vue?vue&type=template&id=199d3f64"
import script from "./ChainEditDialog.vue?vue&type=script&lang=js"
export * from "./ChainEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports